module.exports = __webpack_public_path__ + "img/DE03871.b30e3dd2.png";